module.exports = __webpack_public_path__ + "media/puzzle8_9.e5c1f748.mp3";